import SlideFrame from "./_SlideFrame";

const items = [
  {
    t: "30+ integrations",
    d: "LoanPro, Giact, Paya, Sage, Geti, Equifax, Auth.net and more — pick the rails that fit your stack.",
  },
  {
    t: "API-driven by default",
    d: "Seamless connections with your origination, KYC, BI, and treasury stack.",
  },
  {
    t: "PCI-DSS · SOC-aligned · encrypted",
    d: "PCI-DSS Level 1 controls, AES-256 at rest, TLS 1.3 in transit. End-to-end protection for borrowers and partners.",
  },
  {
    t: "Audit trails & logging",
    d: "Immutable system logs for oversight, accountability, and examiner-ready reporting.",
  },
];

export default function SlideBuiltForScale() {
  return (
    <SlideFrame tag="09 · Platform">
      <p className="overline mb-6">Platform foundations</p>
      <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95] font-medium max-w-4xl">
        Built on proven infrastructure — <em className="italic">not reinvented</em> from scratch.
      </h2>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-foreground/20 border border-foreground/20">
        {items.map((it, i) => (
          <div key={i} className="bg-background p-8 min-h-[200px]">
            <p className="font-mono-data text-xs text-muted-foreground mb-6">{String(i + 1).padStart(2, "0")}</p>
            <h3 className="font-display text-2xl leading-tight">{it.t}</h3>
            <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{it.d}</p>
          </div>
        ))}
      </div>
    </SlideFrame>
  );
}
